import * as React from "react";
const SvgFiRrWarranty = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-warranty_svg__a)">
      <path
        fill="#062147"
        d="M7.283 3.697a.999.999 0 1 1 1.435-1.393l2.374 2.442a.907.907 0 0 0 1.266-.007L16.792.294a.999.999 0 1 1 1.416 1.412l-4.439 4.45a2.9 2.9 0 0 1-2.049.841c-.74 0-1.487-.283-2.052-.847zM21 3c-1.654 0-3 1.346-3 3v5.184a3 3 0 0 0-.832-.18 3 3 0 0 0-2.173.77l-3.009 2.767c-.082-.084-.16-.172-.247-.252l-2.744-2.525a2.99 2.99 0 0 0-2.996-.579V6c0-1.654-1.346-3-3-3A3.004 3.004 0 0 0 0 6v10.101c0 2.137.832 4.146 2.343 5.657l1.95 1.95a1 1 0 0 0 1.414 0 1 1 0 0 0 0-1.414l-1.95-1.95A5.96 5.96 0 0 1 2 16.101v-10.1c0-.552.449-1 1-1s1 .448 1 1c0 0-.005 8.076 0 8.117.03.654.286 1.308.747 1.854l2.616 2.721a1 1 0 1 0 1.442-1.386l-2.57-2.67a1 1 0 0 1 .021-1.306.994.994 0 0 1 1.397-.086l2.734 2.516a5.01 5.01 0 0 1 1.615 3.68v3.56a1 1 0 0 0 2 0v-3.56a7 7 0 0 0-.824-3.276l3.163-2.91a.97.97 0 0 1 .72-.254 1 1 0 0 1 .687.33c.16.178.241.402.255.623v.047a.9.9 0 0 1-.188.584l-2.533 2.634a1 1 0 0 0 1.441 1.386l2.578-2.685c.45-.536.686-1.195.701-1.857.002-.023 0-8.065 0-8.065a1.001 1.001 0 0 1 2 0V16.1a5.96 5.96 0 0 1-1.757 4.243l-1.95 1.95a.999.999 0 1 0 1.414 1.414l1.95-1.95a7.95 7.95 0 0 0 2.343-5.657V6c0-1.654-1.346-3-3-3z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-warranty_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWarranty;
